<div class="p-regular flex-wrap d-flex gap-regular">
  <button class="btn btn-primary btn-animated"><span>Primary</span></button>
  <button class="btn btn-secondary btn-animated"><span>Secondary</span></button>
  <button class="btn btn-link">Tertiary</button>
</div>

<div class="bg-primary flex-wrap m-huge-y p-regular d-flex gap-regular">
  <button class="btn btn-primary btn-animated"><span>Primary</span></button>
  <button class="btn btn-secondary btn-animated"><span>Secondary</span></button>
  <button class="btn btn-link">Tertiary</button>
</div>
